/* eslint-disable no-plusplus */
import Resizer from 'react-image-file-resizer';

export const objectify = obj => {
  const result = {};
  Object.keys(obj).forEach(key => {
    const keys = key.split('.');
    keys.reduce((acc, cur, index) => {
      if (index === keys.length - 1) {
        acc[cur] = obj[key];
      } else if (!acc[cur]) {
        acc[cur] = {};
      }
      return acc[cur];
    }, result);
  });
  return result;
};
export const deobjectify = obj => {
  const result = {};
  // eslint-disable-next-line no-shadow
  const recurse = (obj, current) => {
    Object.keys(obj).forEach(key => {
      const newKey = current ? `${current}.${key}` : key;
      if (typeof obj[key] === 'object') {
        recurse(obj[key], newKey);
      } else {
        result[newKey] = obj[key];
      }
    });
  };
  recurse(obj);
  return result;
};
export const setCookie = (name, value, days, domain = '') => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  if (domain) {
    document.cookie = `${name}=${value || ''}${expires}; samesite=lax; path=/; domain=${domain}; secure`;
  } else document.cookie = `${name}=${value || ''}${expires}; samesite=lax; path=/; secure`;
  return true;
};

export const getCookie = name => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const clearCookie = name => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

  return true;
};

export const capitalize = (str = '') => {
  const arr = str.toLowerCase().split(' ');

  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const str2 = arr.join(' ');
  return str2;
};

export const getStatusIconClass = (status = '') => {
  switch (status.trim().toLowerCase()) {
    case 'active':
      return 'check_circle';
    case 'blocked':
      return 'lock';
    case 'pendingactivation':
      return 'settings';
    default:
      return 'cancel';
  }
};

function changeTimezone(date, ianatz) {
  // suppose the date is 12:00 UTC
  const invdate = new Date(
    date.toLocaleString('en-US', {
      timeZone: ianatz,
    }),
  );

  const diff = date.getTime() - invdate.getTime();

  return new Date(date.getTime() - diff); // needs to substract
}

export const getDateObject = e => changeTimezone(new Date(e), 'Canada/Eastern');

export const getGeoCoder = () => {
  if (typeof window === 'undefined' || !window.google?.maps?.Geocoder) return null;
  return new window.google.maps.Geocoder();
};

export const GeoCode = async value => {
  const geoCoder = getGeoCoder();
  if (!geoCoder) {
    throw new Error('Google Maps API is not loaded (Geocoder unavailable).');
  }

  const { results } = await geoCoder.geocode(value);
  const { address_components, geometry, place_id, formatted_address } = results[0];
  const address = {};
  // eslint-disable-next-line no-shadow
  address_components?.forEach(({ short_name, types }) => {
    if (types.includes('administrative_area_level_1')) {
      address.state = short_name;
    } else if (types.includes('administrative_area_level_2')) {
      address.county = short_name;
    } else if (types.includes('locality')) {
      address.city = short_name;
    } else address[types[0]] = short_name;
  });

  return {
    ...address,
    place_id,
    latlng: {
      lat: geometry?.location?.lat(),
      lng: geometry?.location?.lng(),
    },
    formatted_address,
  };
};

export const generatePsscode = length => {
  let zero = '';
  for (let index = 1; index < length; index++) {
    zero += '0';
  }
  const firstVal = 1 + zero;
  const secondVal = 9 + zero;
  return Math.floor(Number(firstVal) + Math.random() * Number(secondVal));
};

export const mergeNames = _ => {
  let name = null;
  if (_.first_name) {
    name = `${_?.first_name} ${_?.last_name}`;
  }
  return name;
};

export const removeDuplicatedArrayElements = array =>
  Array.from(new Set(array.map(_ => JSON.stringify(_)))).map(str => JSON.parse(str));

export function compareJSON(originalJSON, updatedJSON) {
  const updatedLines = {};
  const oldLines = {};

  const compareObjects = (originalObj, updatedObj, path = '') => {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const key in originalObj) {
      const originalValue = originalObj[key];

      // eslint-disable-next-line no-prototype-builtins
      if (updatedObj.hasOwnProperty(key)) {
        const updatedValue = updatedObj[key];
        const nestedPath = path ? `${path}.${key}` : key;

        if (typeof originalValue === 'object' && typeof updatedValue === 'object') {
          compareObjects(originalValue, updatedValue, nestedPath);
        } else if (originalValue !== updatedValue) {
          updatedLines[nestedPath] = updatedValue;
          oldLines[nestedPath] = originalValue;
        }
      } else {
        const nestedPath = path ? `${path}.${key}` : key;
        oldLines[nestedPath] = originalValue;
      }
    }
  };

  compareObjects(originalJSON, updatedJSON);

  return { updatedLines, oldLines };
}

export const compressImage = file =>
  new Promise(resolve => {
    Resizer.imageFileResizer(
      file,
      Infinity,
      Infinity,
      'PNG',
      70,
      0,
      uri => {
        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          // Set the canvas dimensions to match the image plus border
          const canvasWidth = image.width + 800; // Adjust border width as desired
          const canvasHeight = image.height;
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;

          // Draw the left border
          context.fillStyle = 'white'; // Set border color
          context.fillRect(0, 0, 400, canvasHeight);

          // Draw the right border
          context.fillStyle = 'white'; // Set border color
          context.fillRect(canvasWidth - 400, 0, 400, canvasHeight);

          // Draw the image in the center of the canvas
          const imageX = 400; // Adjust border width as desired
          const imageY = 0;
          context.drawImage(image, imageX, imageY);

          // Convert the modified image on the canvas to base64 (PNG format)
          const modifiedImageData = canvas.toDataURL('image/png');
          resolve(modifiedImageData);
        };

        image.src = uri;
      },
      'base64',
      600,
      600,
    );
  });

export const capitalizeFirstLetter = sentence => {
  const words = sentence.split(' ');
  const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
  const capitalizedSentence = capitalizedWords.join(' ');
  return capitalizedSentence;
};

export const getDateStringFromFileName = fileName => {
  const regex = /PSP_Daily_settlement_(\d{6})\.csv/;
  const match = fileName.match(regex);

  if (match && match[1]) {
    return match[1];
  }

  return null;
};

export const getSource = networkType => {
  if (!networkType) {
    return 'https://img.icons8.com/color/48/000000/cash.png';
  }

  switch (networkType.toLowerCase()) {
    case 'visa':
      return 'https://img.icons8.com/color/48/000000/visa.png';
    case 'mastercard':
      return 'https://img.icons8.com/color/48/000000/mastercard.png';
    case 'amex':
      return 'https://img.icons8.com/color/48/000000/amex.png';
    case 'discover':
      return 'https://img.icons8.com/color/48/000000/discover.png';
    case 'diners-club':
      return 'https://img.icons8.com/color/48/000000/diners-club.png';
    case 'jcb':
      return 'https://img.icons8.com/color/48/000000/jcb.png';
    case 'unionpay':
      return 'https://img.icons8.com/color/48/000000/unionpay.png';
    case 'cash':
      return 'https://img.icons8.com/color/48/000000/cash.png';
    case 'interac':
      return 'https://logowik.com/content/uploads/images/interac6656.logowik.com.webp';
    default:
      return 'https://img.icons8.com/color/48/000000/cash.png';
  }
};

export const formatCurrency = amount => {
  if (amount === undefined || amount === null) {
    return '0.00';
  }
  const amountFixed = parseFloat(amount).toFixed(2);

  const [integerPart, decimalPart] = amountFixed.split('.');

  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return `$ ${formattedIntegerPart}.${decimalPart}`;
};

export const filterSelectCard = values => {
  const cards = values.map(card => ({
    label: (
      <div className="select-label">
        <img src={getSource(card)} alt="card" />
        {card.toLowerCase() === 'credit' ? 'Manual' : card}
      </div>
    ),
    value: card,
  }));

  return cards;
};
